import { Command } from '@/app/common/base/command'

export class DeleteMyUploadedDocumentCommand extends Command {
    public async run(id: string): Promise<void> {
        await this.client.getClient().post(`/api/my-uploaded-documents/${id}`)
    }
}
